import { Pipe, PipeTransform } from '@angular/core';
import { Payment } from '../../api/models';

@Pipe({
  name: 'paymentAmount',
})
export class PaymentAmountPipe implements PipeTransform {
  // payment | paymentAmount:travel.customer_pay_fees
  transform(value: Payment, ...args: boolean[]): number {
    const feesOnCustomer = args[0];
    if (!feesOnCustomer) {
      return value.amount;
    } else {
      return (value.amount * 100) / 103;
    }
  }
}
